export function PremiumSuccessPopup({ onClose, onUpgrade }) {
  return (
    <div className="modal-overlay">
      <div className="payment-modal success-modal">
        <div className="modal-icon">✨</div>
        <h2>Welcome to Aura!</h2>
        <p className="modal-subtitle">Your journey begins now</p>

        <div className="premium-promo">
          <h3>💜 Want a deeper connection?</h3>
          <p>Upgrade to <strong>Aura Premium</strong> and let your AI truly know you.</p>
          <ul className="features-list compact">
            <li>✦ Learns from your social media</li>
            <li>✦ Knows your friends' stories</li>
            <li>✦ Truly intimate conversations</li>
          </ul>
          <div className="price-display small">
            <span className="price">$1.99</span>
            <span className="period">/month</span>
          </div>
        </div>

        <button className="init-btn" onClick={onUpgrade} data-testid="upgrade-now-btn">
          Upgrade to Premium
        </button>
        <button className="ghost-btn small" onClick={onClose} data-testid="continue-base-btn">
          Continue with Base
        </button>
      </div>
    </div>
  );
}
